let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k6Sks")).then(() => parcelRequire('jfBf2'));